/** @format */

import { FormattedMessage } from 'gatsby-plugin-intl';
import moment from 'moment';
import React, { memo } from 'react';
import styled from 'styled-components';
import { selectorBookingAvailability } from '../../../../@ducks/bookingNew/selectors';
import { TRoom } from '../../../../@ducks/room/declarations';
import { useAppSelector } from '../../../../redux/hooks';
import { utilityIsRoomAvailableFrom } from '../../../../utils/helpers/isRoomAvailableFrom';
import { utilityGetPrice } from '../../../../utils/helpers/utilityGetPrice';
import { RoomInfoDiscountPrice } from '../../../shared/CardRoom/partials/RoomInfoDiscountPrice';

interface RoomInfoPricePromoProps {
  room: Omit<
    TRoom,
    | 'accomodationType'
    | 'countryCode'
    | 'flat'
    | 'legalEntity'
    | 'id'
    | 'salableOnline'
    | 'dateDifference'
    | 'resultType'
    | 'bedroomAvailableCount'
  >;
}

const RoomInfoPricePromo: React.FC<RoomInfoPricePromoProps> = ({ room }) => {
  const availability = useAppSelector(selectorBookingAvailability);
  const { getDiscountUntilDate, hasPromo, getDiscountedPrice, getBasePrice } = utilityGetPrice({
    availability,
    room: room as TRoom,
  });
  const formattedDiscountUntilDate = moment(getDiscountUntilDate()).format('DD/MM/YYYY');
  const isRoomAvailableFrom = utilityIsRoomAvailableFrom(availability);

  return (
    <>
      {hasPromo() ? (
        <RoomInfoDiscountPrice
          isSuitableForCouples={room.flatFeatures.twoOccupantsAllowed}
          availability={availability}
          oldPrice={getBasePrice()}
          newPrice={getDiscountedPrice()}
          endPromo={formattedDiscountUntilDate}
        />
      ) : (
        isRoomAvailableFrom && (
          <AvailabilityAvailableFromContainer>
            <AvailabilityAvailableFrom>
              <FormattedMessage id="available_from" /> {moment(availability?.availableFrom).format('DD/MM/YYYY')}
            </AvailabilityAvailableFrom>
          </AvailabilityAvailableFromContainer>
        )
      )}
    </>
  );
};

export default memo(RoomInfoPricePromo);

const AvailabilityAvailableFromContainer = styled.div`
  font-size: 12px;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  max-width: 300px;
  margin: 0 auto;
  margin-bottom: 25px;
  display: none;
  @media screen and (max-width: ${props => props.theme.breakpoints.lg}) {
    display: flex;
  }
  align-items: center;
`;

const AvailabilityAvailableFrom = styled.div`
  margin: 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.joivy.pink};
  font-size: 14px;
  font-family: ${({ theme }) => theme.font.title};
`;
